import { render, staticRenderFns } from "./certification-part-two-preview-form.component.vue?vue&type=template&id=36284b08"
import script from "./certification-part-two-preview-form.component.ts?vue&type=script&lang=ts&external"
export * from "./certification-part-two-preview-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./certification-part-two-preview-form.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports